import { defineMessages } from 'react-intl';

export default defineMessages({
  // Footer
  stratzCopyright: '© 2015-{currentYear} STRATZ, LLC. All Rights Reserved.',
  stratzTrademark: 'The STRATZ Logo is a registered trademark of STRATZ, LLC. All Rights Reserved.',
  dotaTrademark: 'Dota 2, and the Dota 2 logo are registered trademarks of Valve Corporation.',
});
